export const viewMoreChallans = {
    event: "view_more_challans",
    eventAction: "View_more_offences",
    eventCategory: "Challan_homepage"
};
